
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.248 4.173A14.61 14.61 0 0012.534 3c-.16.29-.347.681-.476.992a13.571 13.571 0 00-4.115 0c-.129-.31-.32-.701-.481-.992a14.562 14.562 0 00-3.717 1.175C1.395 7.744.758 11.223 1.076 14.654a14.822 14.822 0 004.555 2.345c.367-.508.694-1.046.975-1.615a9.583 9.583 0 01-1.536-.75c.13-.097.255-.197.377-.3 2.962 1.392 6.18 1.392 9.106 0 .123.103.25.203.377.3a9.55 9.55 0 01-1.54.752c.282.567.608 1.107.976 1.614a14.792 14.792 0 004.558-2.346c.373-3.977-.639-7.425-2.676-10.482zM7.01 12.544c-.89 0-1.618-.834-1.618-1.85 0-1.015.713-1.85 1.618-1.85.905 0 1.634.833 1.618 1.85.002 1.016-.713 1.85-1.618 1.85zm5.98 0c-.889 0-1.618-.834-1.618-1.85 0-1.015.713-1.85 1.618-1.85.905 0 1.634.833 1.618 1.85 0 1.016-.713 1.85-1.618 1.85z"}})])
          )
        }
      }
    